import { useState, useEffect } from 'react';
import { CostsComponent, configureCostsAuth, authEvents } from '@umd-dit/cost-component-react';
import '@umd-dit/cost-component-react/style.css';
import { addAuthHeaders } from '@umd-dit/oidc-core';

export default function Costs() {
  const [theme, setTheme] = useState<'light' | 'dark'>('light');

  // Configure the cost component with the addAuthHeaders from OIDC core
  useEffect(() => {
    try {
      // Check if addAuthHeaders is available
      if (typeof addAuthHeaders !== 'function') {
        throw new Error('addAuthHeaders from OIDC core is not available');
      }
      
      // Pass the addAuthHeaders function to the cost component
      configureCostsAuth(addAuthHeaders);
      console.log('Cost component configured with legislative-review auth mechanism');
      
      // Subscribe to auth error events from the cost component
      const unsubscribe = authEvents.onAuthError((event) => {
        console.warn('Auth error received in parent component:', event);
        // You could redirect to login page or trigger OIDC re-authentication here
      });
      
      // Clean up the subscription when component unmounts
      return () => {
        unsubscribe();
      };
    } catch (error) {
      console.error('Error configuring costs auth:', error);
      // Display an error message to the user
      alert('Failed to initialize costs component. Authentication configuration error.');
    }
  }, []); // No dependencies since addAuthHeaders is imported directly

  return (
    <div className="container mx-auto px-4 py-4">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center space-x-2">
          <span className="text-sm">Theme:</span>
          <button
            onClick={() => setTheme('light')}
            className={`px-3 py-1 rounded-md text-sm ${theme === 'light' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}
          >
            Light
          </button>
          <button
            onClick={() => setTheme('dark')}
            className={`px-3 py-1 rounded-md text-sm ${theme === 'dark' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}
          >
            Dark
          </button>
        </div>
      </div>
      
      {/* React component instead of web component */}
      <CostsComponent
        appId="legislative-review"
        viewType="summary"
        timePeriod="monthly"
        theme={theme}
        costsApiUrl={import.meta.env.VITE_COSTS_API_URL}
      />
    </div>
  );
}
